<div class="button-list button-list--layout">
  <h6>Quote layout options</h6>
  @if (!showManualQuoteOptions() && !showFclTariffQuoteOptions()) {
    <span class="layout-option">
      <span class="form-control-label required">Offer Language</span>
      <app-locale-select
        [locale]="offerLanguage"
        (localeChange)="offerLanguage = $event; dispatchQuoteEvents()"
      >
      </app-locale-select>
    </span>
  }
  @if (showFclQuoteOptions()) {
    <span class="layout-option">
      <span class="form-control-label required">Sort freight rates by</span>
      <p-select
        [(ngModel)]="selectedFreightRateOrder"
        (onChange)="dispatchQuoteEvents()"
        [options]="freightRateOrderList"
        [filter]="true"
        filterBy="label, value"
      >
      </p-select
      ><span class="form-control-label required">then by:</span>
      <p-select
        [(ngModel)]="selectedFreightRateSecondOrder"
        (onChange)="dispatchQuoteEvents()"
        [options]="freightRateSecondOrderList"
        [filter]="true"
        placeholder="None"
        filterBy="label, value"
      >
      </p-select>
    </span>
  }
  @if (showCarrierOptions && !showPtlQuoteOptions()) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="showCarrierName"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="showCarrierName"
      >
      </p-checkbox>
      <label for="showCarrierName">Show service name for freight</label>
    </span>
  }
  @if (showFclQuoteOptions()) {
    <span [hidden]="!showCarrierName" class="layout-option">
      <p-checkbox
        [(ngModel)]="showServiceNameForLocalCharges"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="showServiceNameForLocalCharges"
      >
      </p-checkbox>
      <label for="showServiceNameForLocalCharges"
        >Show service name for local charges</label
      >
    </span>
  }
  @if (showFclQuoteOptions()) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="showRateName"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="showRateName"
      >
      </p-checkbox>
      <label for="showRateName">Show contract name</label>
    </span>
  }
  @if (showFclQuoteOptions() || showLclQuoteOptions()) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="showRateValidity"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="showRateValidity"
      >
      </p-checkbox>
      <label for="showRateValidity">Show contract validity</label>
    </span>
  }
  @if (showFclQuoteOptions()) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="showRateSurcharges"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="showRateSurcharges"
      >
      </p-checkbox>
      <label for="showRateSurcharges"
        >Show surcharges separately on the offer</label
      >
    </span>
  }
  @if (showManualQuoteOptions()) {
    <span class="layout-option">
      Select Terms & Conditions:
      <app-manual-quote-type-select
        [manualQuoteType]="manualQuoteType"
        (manualQuoteTypeChange)="
          manualQuoteType = $event; dispatchQuoteEvents()
        "
      >
      </app-manual-quote-type-select>
    </span>
  }

  @if (showFclTariffQuoteOptions()) {
    <span class="layout-option">
      <p-select
        [(ngModel)]="showAllLocationsInOneSheet"
        (onChange)="dispatchQuoteEvents()"
        [options]="showAllLocationsInOneSheetOptions"
        [filter]="true"
        filterBy="label, value"
        class="all-locations-dropdown"
      >
      </p-select>
    </span>
  }

  @if (showModifyTermsAndConditions() && !showMultiQuoteOptions()) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="termsEditorEnabled"
        (onChange)="dispatchTermsEvents()"
        binary="true"
        inputId="modifyTermsAndConditions"
      >
      </p-checkbox>
      <label for="modifyTermsAndConditions">Modify Terms & Conditions</label>
    </span>
  }

  @if (
    showBaseStandardQuoteOptions() &&
    !showAirTariffQuoteOptions() &&
    !showMultiQuoteOptions()
  ) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="showInvoiceInfo"
        [binary]="true"
        (ngModelChange)="dispatchQuoteEvents()"
        name="currency"
        inputId="showInvoiceCurrency"
      >
      </p-checkbox>
      <label for="showInvoiceCurrency">Show invoice currency in</label>
      <p-multiselect
        [selectAll]="null"
        [ngModel]="invoiceCurrency"
        [disabled]="!showInvoiceInfo"
        (ngModelChange)="invoiceCurrency = $event; dispatchQuoteEvents()"
        [options]="currencySelectList"
        [maxSelectedLabels]="1"
        placeholder="Please select"
        [filter]="true"
        filterBy="label, value"
      >
      </p-multiselect>
    </span>
  }

  @if (
    !showFclTariffQuoteOptions() &&
    !showManualQuoteOptions() &&
    !showLtlQuoteOptions() &&
    !showAirTariffQuoteOptions() &&
    !showMultiQuoteOptions() &&
    !showFtlQuoteOptions() &&
    !showPtlQuoteOptions()
  ) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="groupOriginSurcharges"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="groupOriginSurcharges"
      >
      </p-checkbox>
      <label for="groupOriginSurcharges">Group origin charges in</label>
      <p-select
        [(ngModel)]="selectedOriginSurchargeCurrency"
        [disabled]="!groupOriginSurcharges"
        (onChange)="dispatchQuoteEvents()"
        [options]="currencySelectList"
        [filter]="true"
        filterBy="label, value"
      >
      </p-select>
    </span>
  }
  @if (
    !showFclTariffQuoteOptions() &&
    !showManualQuoteOptions() &&
    !showLtlQuoteOptions() &&
    !showAirTariffQuoteOptions() &&
    !showMultiQuoteOptions() &&
    !showFtlQuoteOptions() &&
    !showPtlQuoteOptions()
  ) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="groupDestinationSurcharges"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="groupDestinationSurcharges"
      >
      </p-checkbox>
      <label for="groupDestinationSurcharges"
        >Group destination charges in</label
      >
      <p-select
        [(ngModel)]="selectedDestinationSurchargeCurrency"
        [disabled]="!groupDestinationSurcharges"
        (onChange)="dispatchQuoteEvents()"
        [options]="currencySelectList"
        [filter]="true"
        filterBy="label, value"
      >
      </p-select>
    </span>
  }
  @if (showFclQuoteOptions()) {
    <span class="layout-option">
      <p-checkbox
        [(ngModel)]="groupRoutes"
        (onChange)="dispatchQuoteEvents()"
        binary="true"
        inputId="groupRoutes"
      >
      </p-checkbox>
      <label for="groupRoutes">Group by route</label>
    </span>
  }

  @if (
    (showCurrencyOptions || showLtlQuoteOptions()) &&
    !showFtlQuoteOptions() &&
    !showPtlQuoteOptions()
  ) {
    <div class="m-t-30">
      <h6>Totals & Currencies</h6>
      @if (showLtlQuoteOptions()) {
        <span class="layout-option">
          <!-- For LTL Quotes this field works in binary (YES / NO) Mode -->
          <p-checkbox
            [(ngModel)]="showTotal"
            (ngModelChange)="dispatchQuoteEvents()"
            name="currency"
            binary="true"
            inputId="showTotalCurrency"
          >
          </p-checkbox>
          <label for="showTotalCurrency">Show total in</label>
          <p-select
            [(ngModel)]="selectedTotalCurrency"
            [disabled]="!showTotal"
            (onChange)="dispatchQuoteEvents()"
            [options]="currencySelectList"
            [filter]="true"
            filterBy="label, value"
          >
          </p-select>
          <i
            class="pi pi-question-circle"
            pTooltip="Rate of Exchange as per finance.google.com"
            tooltipPosition="bottom"
            hideDelay="0"
          >
          </i>
        </span>
      }
      @if (showLtlQuoteOptions()) {
        <span class="layout-option">
          <p-checkbox
            [(ngModel)]="showNoMarginSurcharges"
            (ngModelChange)="showRateSurcharges = false; dispatchQuoteEvents()"
            name="currency"
            binary="true"
            inputId="showNoMarginSurcharges"
          >
          </p-checkbox>
          <label for="showNoMarginSurcharges"
            >Show surcharges without margin separately</label
          >
        </span>
      }
      @if (showLtlQuoteOptions()) {
        <span class="layout-option">
          <p-checkbox
            [(ngModel)]="showRateSurcharges"
            (ngModelChange)="
              showNoMarginSurcharges = false; dispatchQuoteEvents()
            "
            name="currency"
            binary="true"
            inputId="showRateSurcharges"
          >
          </p-checkbox>
          <label for="showRateSurcharges"
            >Show all surcharges separatelly</label
          >
        </span>
      }
      @if (showCurrencyOptions && !showMultiQuoteOptions()) {
        <span class="layout-option">
          <p-radiobutton
            [(ngModel)]="totalType"
            [value]="quoteOptionsCurrencyType.none"
            (ngModelChange)="dispatchQuoteEvents()"
            name="currency"
            inputId="showChargesSeparately"
          >
          </p-radiobutton>
          <label for="showChargesSeparately">Show charges separately</label>
        </span>
      }
      @if (showCurrencyOptions && showChargesInTotalCurrencyOption()) {
        <span class="layout-option">
          <p-radiobutton
            [(ngModel)]="totalType"
            [value]="quoteOptionsCurrencyType.chargesConverted"
            (ngModelChange)="dispatchQuoteEvents()"
            name="currency"
            inputId="showChargesSeparatelyIn"
          >
          </p-radiobutton>
          <label for="showChargesSeparatelyIn"
            >Show charges separately in</label
          >
          <p-select
            [(ngModel)]="selectedChargesCurrency"
            [disabled]="totalType !== quoteOptionsCurrencyType.chargesConverted"
            (onChange)="dispatchQuoteEvents()"
            [options]="currencySelectList"
            [filter]="true"
            filterBy="label, value"
          >
          </p-select>
          <i
            class="pi pi-question-circle"
            pTooltip="Rate of Exchange as per finance.google.com"
            tooltipPosition="bottom"
            hideDelay="0"
          >
          </i>
        </span>
      }
      @if (
        isCurrencyGroupingEnabled() &&
        !hasMoreThanOneLocation &&
        !showMultiQuoteOptions()
      ) {
        <span class="layout-option">
          <p-radiobutton
            [(ngModel)]="totalType"
            [value]="quoteOptionsCurrencyType.subTotals"
            (ngModelChange)="dispatchQuoteEvents()"
            name="currency"
            inputId="showSubTotals"
          >
          </p-radiobutton>
          <label for="showSubTotals">Show subtotals grouped by currency</label>
        </span>
      }
      @if (showCurrencyOptions && !hasMoreThanOneLocation) {
        <span class="layout-option">
          <p-radiobutton
            [(ngModel)]="totalType"
            [value]="quoteOptionsCurrencyType.subTotalsConverted"
            (ngModelChange)="dispatchQuoteEvents()"
            name="currency"
            inputId="showTotalIn"
          >
          </p-radiobutton>
          <label for="showTotalIn">Show total in</label>
          <p-select
            [(ngModel)]="selectedTotalCurrency"
            [disabled]="
              totalType !== quoteOptionsCurrencyType.subTotalsConverted
            "
            (onChange)="dispatchQuoteEvents()"
            [options]="currencySelectList"
            [filter]="true"
            filterBy="label, value"
          >
          </p-select>
          <i
            class="pi pi-question-circle"
            pTooltip="Rate of Exchange as per finance.google.com"
            tooltipPosition="bottom"
            hideDelay="0"
          >
          </i>
        </span>
      }
      @if (showCurrencyOptions && !hasMoreThanOneLocation) {
        <span class="layout-option">
          <p-radiobutton
            [(ngModel)]="totalType"
            [value]="quoteOptionsCurrencyType.subTotalsConvertedWithFreight"
            (ngModelChange)="dispatchQuoteEvents()"
            name="currency"
            inputId="showTotalInWithFreight"
          >
          </p-radiobutton>
          <label for="showTotalInWithFreight">Show ALL-IN rate in</label>
          <p-select
            [(ngModel)]="selectedTotalCurrency"
            [disabled]="
              totalType !==
              quoteOptionsCurrencyType.subTotalsConvertedWithFreight
            "
            (onChange)="dispatchQuoteEvents()"
            [options]="currencySelectList"
            [filter]="true"
            filterBy="label, value"
          >
          </p-select>
          <i
            class="pi pi-question-circle"
            pTooltip="Rate of Exchange as per finance.google.com"
            tooltipPosition="bottom"
            hideDelay="0"
          >
          </i>
        </span>
      }
      @if (isEquipmentQuantityEnabled()) {
        <div class="box-batch-actions">
          <span class="layout-option">
            <app-equipment-quantity
              [equipment]="quote().getEquipment()"
              [quote]="quote()"
              [equipmentQuantity]="equipmentQuantity"
              [showGrandTotal]="showGrandTotal"
              [grandTotalCurrency]="grandTotalCurrency"
              [currencySelectList]="currencySelectList"
              (dispatchedQuoteEvents)="updateGrandTotalParams($event)"
            >
            </app-equipment-quantity>
          </span>
        </div>
      }
    </div>
  }

  @if (showFclTariffQuoteOptions()) {
    <div>
      @if (!showAllLocationsInOneSheet) {
        <div>
          <span class="layout-option">
            <p-checkbox
              [(ngModel)]="showRateSurcharges"
              (ngModelChange)="dispatchQuoteEvents()"
              binary="true"
              inputId="showRateSurcharges"
            >
            </p-checkbox>
            <label for="showRateSurcharges">Show surcharges separately</label>
          </span>
          <span class="layout-option">
            <p-checkbox
              [(ngModel)]="showInternalNotes"
              (onChange)="dispatchQuoteEvents()"
              binary="true"
              inputId="showInternalNotes"
            >
            </p-checkbox>
            <label for="showInternalNotes"
              >Show internal notes from the contract</label
            >
          </span>
          <span class="layout-option">
            <p-checkbox
              [(ngModel)]="showExternalNotes"
              (onChange)="dispatchQuoteEvents()"
              binary="true"
              inputId="showExternalNotes"
            >
            </p-checkbox>
            <label for="showExternalNotes"
              >Show additional notes from the contract</label
            >
          </span>
          <span class="layout-option">
            <p-checkbox
              [(ngModel)]="showRateName"
              (onChange)="dispatchQuoteEvents()"
              binary="true"
              inputId="showRateName"
            >
            </p-checkbox>
            <label for="showRateName">Show contract name</label>
          </span>
        </div>
      }
      <span class="layout-option">
        <p-checkbox
          [(ngModel)]="specifyLocations"
          binary="true"
          (ngModelChange)="specifyLocationsChanged()"
          inputId="specifyLocations"
        >
        </p-checkbox>
        <label for="specifyLocations"
          >Specify origin and destination locations</label
        >
      </span>
      @if (specifyLocations) {
        <div class="row m-t-30 location-options">
          <div class="col-sm-6">
            <h6>
              Origin Locations:
              <i
                class="pi pi-question-circle"
                pTooltip="If nothing selected, all locations will be used."
                tooltipPosition="right"
              >
              </i>
            </h6>
            <p-multiselect
              [selectAll]="null"
              [options]="originLocationList"
              [ngModel]="selectedOriginLocations"
              dataKey="id"
              maxSelectedLabels="3"
              placeholder="Please select"
              selectedItemsLabel="{0} origin locations"
              (ngModelChange)="
                selectedOriginLocations = $event; originLocationChange()
              "
            >
            </p-multiselect>
          </div>
          <div class="col-sm-6">
            <h6>
              Destination Locations:
              <i
                class="pi pi-question-circle"
                pTooltip="If nothing selected, all locations will be used."
                tooltipPosition="right"
              >
              </i>
            </h6>
            <p-multiselect
              [selectAll]="null"
              [options]="destinationLocationList"
              [ngModel]="selectedDestinationLocations"
              dataKey="id"
              maxSelectedLabels="3"
              placeholder="Please select"
              selectedItemsLabel="{0} destination locations"
              (ngModelChange)="
                selectedDestinationLocations = $event;
                destinationLocationChange()
              "
            >
            </p-multiselect>
          </div>
        </div>
      }
    </div>
  }
  @if (showBaseStandardQuoteOptions()) {
    <div class="m-t-30">
      <h6>Insurance</h6>
      <app-quote-insurance
        variant="layout"
        [quote]="quote()"
        [user]="user"
        [disabled]="insuranceDisabled()"
        (apply)="insuranceApply.emit($event)"
      >
      </app-quote-insurance>
    </div>
  }
  @if (exchangeRates(); as exchangeRates) {
    <div class="m-t-30 exchange-rates">
      <h6>Exchange rate</h6>
      <p class="exchange-rates-spread">Spread: {{ exchangeRates.spread }}%</p>
      @for (exchangeRate of exchangeRates.rates; track $index) {
        <div class="exchange-rate">
          <span
            [pTooltip]="
              exchangeRateEquation(exchangeRate, exchangeRates.spread)
            "
            tooltipPosition="right"
          >
            1 {{ exchangeRate.from }} =
            {{ exchangeRate.rateWithSpread | number: "1.0-6" }}
            {{ exchangeRate.to }}
          </span>
          <button
            pButton
            type="button"
            size="small"
            [text]="true"
            aria-label="Copy exchange rate"
            (click)="copyToClipboard(exchangeRate.rateWithSpread)"
          >
            <i class="pi pi-copy"></i>
          </button>
        </div>
      }
    </div>
  }
</div>
